
export const darkTheme = {
  mode: "Light",
  backgroundPrimary: "#141c2f",
  backgroundSecondary: "#1f2a48",
  fontTitle: "#fbffff",
  fontSubtitle: "#ffffff",
  button: "#0278FC",
  buttonHover: "blue",
  colorButton: "#D9E5F1",
  shadow: "#131b2e"
}

export const lightTheme = {
  mode: "Dark",
  backgroundPrimary: "#f5f8ff",
  backgroundSecondary: "#FEFEFE",
  fontTitle: "#2c2f3e",
  fontSubtitle: "#2c2a3e",
  button: "#0278FC",
  buttonHover: "blue",
  colorButton: "#D9E5F1",
  shadow: "#b5bcc4"
}